<template>
  <div
    class="user-avatar d-flex flex-row justify-content-center align-items-center"
  >
    <div
      v-if="hasInitials"
      class="initials i-text-primary-110 i-text-button-3 d-flex flex-row justify-content-center align-items-center"
      data-testid="user-initials"
    >
      {{ hasInitials }}
    </div>
    <i-icon
      v-else
      symbol="medium-user-single"
      :colour="palette['light-primary-110']"
      :size="16"
    ></i-icon>
  </div>
</template>

<script>
import { iIcon } from '@inscribe/signal';
import palette from '@inscribe/signal/dist/palette';

export default {
  components: { iIcon },
  props: {
    user: {
      type: Object,
      required: true,
      default: null,
    },
  },
  data() {
    return {
      palette,
    };
  },
  computed: {
    hasInitials() {
      if (this.user.first_name && this.user.last_name) {
        return `${this.user.first_name.slice(0, 1)}${this.user.last_name.slice(
          0,
          1,
        )}`.toUpperCase();
      } else return null;
    },
  },
};
</script>

<style lang="scss" scoped>
.user-avatar {
  min-width: 32px;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: $light-primary-30;

  .initials {
    width: 100%;
    height: 100%;
  }
}
</style>
